import { ApiConfig } from '@beautybox/core/api';
import { removeSubdomain, getHostWithNewSubdomain } from '@beautybox/core/utils/subdomains';
const isAutoResolveBaseUrl: boolean = !!import.meta.env.VITE_BASE_URL_AUTO
    ? import.meta.env.VITE_BASE_URL_AUTO === 'true'
    : true;
const BASE_URL = isAutoResolveBaseUrl ? removeSubdomain() : import.meta.env.VITE_BASE_URL;

export const config: ApiConfig = {
    module: 'link',
    BASE_URL,
    token: localStorage.getItem('access_token') ?? undefined,
    secure: false,
};

function getVkIdRedirectUrl(): string {
    let newHost = removeSubdomain(true);

    newHost = getHostWithNewSubdomain(newHost, 'auth');

    const protocol = window.location.protocol;

    const newOrigin = `${protocol}//${newHost}`;
    return `${newOrigin}/auth/social-redirect/vk-id`;
}

export const VKID_REDIRECT_URL: string = isAutoResolveBaseUrl
    ? getVkIdRedirectUrl()
    : import.meta.env.VITE_VKID_REDIRECT_URL;

export default config;
